import angular from "angular";
import ngRoute from 'angular-route';
import booksMenu from "../../menu/Menu";
import './App.css';
/** Store Admin */
import { StoreAdminConfig, storeAdminComponent, HandleRouteChangeError } from "./storeAdmin";
/** App Config */
import { AppConfigProvider } from './services/AppConfig';
/** Store Admin Services */
import { StoreAdminServiceProvider } from './services/StoreAdminService';
/** Design Store Dialog */
import { DesignStoreDialogService } from './routes/main/DesignStoreDialog';
/** wsStore */
import { wsStoreComponent, LowercaseDirective } from './routes/main/wsStore';
/** wsNoProc */
import { wsNoProcComponent } from './routes/np/wsNoProc';
/** wsPolicies */
import { wsPoliciesComponent } from './routes/policies/wsPolicies';

/*******************************************************************************
 * @ngdoc  overview
 * @module csm.books.StoreAdmin
 * @description
 * Base module of the ASB Works/myPTEZ/Booster Finance webstore admin application.
 *******************************************************************************/
export default angular
  .module('csm.books.StoreAdmin', [booksMenu, ngRoute])
  /** Store Admin */
  .component('storeAdmin', storeAdminComponent)
  /*-------------------------------------------------------------*/
  /* Configure routes. Resolvers will reject with redirect path. */
  /*-------------------------------------------------------------*/
  .constant('ROUTES', {})
  .config(StoreAdminConfig)
  /*---------------------------------------*/
  /* Redirect routes that fail to resolve. */
  /*---------------------------------------*/
  .run(HandleRouteChangeError)
  /** App Config */
  .provider('AppConfig', AppConfigProvider)
  .run(['AppConfig', function (AppConfig) {}])
  /** Store Admin Services */
  .provider('StoreAdminService', StoreAdminServiceProvider)
  /** Design Store Dialog */
  .service('DesignStoreDialog', DesignStoreDialogService)
  /** wsStore */
  .component('wsStore', wsStoreComponent)
  .directive('lowercase', LowercaseDirective)
  /** wsNoProc */
  .component('wsNoProc', wsNoProcComponent)
  /** wsPolicies */
  .component('wsPolicies', wsPoliciesComponent)
  .name;
